// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Bf_Rv","mainSection":"styles_mainSection__SsLbP"};